module.exports = __webpack_public_path__ + "img/normal_multiplier_1.61f7c60d.png";